export default __webpack_public_path__ + "static/media/busy-lady.21e4d2bf.svg";